import { useEffect as e, useLayoutEffect as t, useState as n } from "react";
//#region src/shared/hooks/use-media-query.ts
var r = typeof window < "u" ? t : e, i = typeof window > "u";
function a(e, { defaultValue: t = !1, initializeWithValue: a = !0 } = {}) {
	let o = (e) => i ? t : window.matchMedia(e).matches, [s, c] = n(() => a ? o(e) : t);
	function l() {
		c(o(e));
	}
	return r(() => {
		let t = window.matchMedia(e);
		return l(), t.addListener ? t.addListener(l) : t.addEventListener("change", l), () => {
			t.removeListener ? t.removeListener(l) : t.removeEventListener("change", l);
		};
	}, [e]), s;
}
//#endregion
export { a as useMediaQuery };
